import { render, staticRenderFns } from "./UserDashboardPetsMySelf.vue?vue&type=template&id=2418f935&scoped=true&"
import script from "./UserDashboardPetsMySelf.vue?vue&type=script&lang=js&"
export * from "./UserDashboardPetsMySelf.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardPetsMySelf.vue?vue&type=style&index=0&id=2418f935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418f935",
  null
  
)

export default component.exports